import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VehicleStoreRequestsDispatcher {
  private readonly _resetProductFormTracker$ = new BehaviorSubject<number>(0);
  readonly resetProductFormRequested$: Observable<number> = this._resetProductFormTracker$.asObservable();

  dispatchResetProductForm(): void {
    this._resetProductFormTracker$.next(this._resetProductFormTracker$.value + 1);
  }
}
